export default {
  FileSizeExceeded: 15436,
};
